import { useMemo, useState } from "react";

import FlowBars from "../../components/director/module1/FlowBars";
import MetricCard from "../../components/director/module1/MetricCard";
import ModuleShell from "../../components/director/module1/ModuleShell";
import ModuleState from "../../components/director/module1/ModuleState";
import useDirectorSurface from "../../components/director/module1/useDirectorSurface";
import { useDirectorContext } from "@contexts/director";
import { formatCents } from "../../utils/directorFormat";
import { currentCompetence, moduleFilters, scenarioLabel } from "./module1Utils";

const Scenarios = () => {
  const { filters } = useDirectorContext();
  const [scenario, setScenario] = useState("base");
  const query = useMemo(() => moduleFilters({ from: currentCompetence(), months: 24, scenario, filters }), [filters, scenario]);
  const weekly = useDirectorSurface("cashflow/weekly", query);
  const series = weekly.data?.series || [];
  const total = series.reduce((value, item) => value + item.netFlowCents, 0);
  const assumptions = weekly.data?.assumptions || {};
  return <ModuleShell
    title="Cenários de fluxo"
    description="Base, conservador e estresse aplicados aos mesmos fatos, com premissas visíveis."
    badge={scenarioLabel(scenario)}
    qualitySources={[weekly]}
  >
    <section className="director-module1__filters"><label className="director-filter-field"><span>Cenário</span><select value={scenario} onChange={(event) => setScenario(event.target.value)}><option value="base">Base</option><option value="conservative">Conservador</option><option value="stress">Estresse</option></select></label></section>
    <ModuleState {...weekly} availability={weekly.data?.availability} onRetry={weekly.reload} />
    {weekly.data && <>
      <section className="director-module1__metrics">
        <MetricCard label="Fluxo líquido · 13 semanas" value={formatCents(total)} note="Entradas menos saídas" tone={total < 0 ? "pressure" : "green"} />
        <MetricCard label="Atraso de entradas" value={`${assumptions.inflowDelayDays || 0} dias`} note="Somente parcelas futuras" tone="blue" />
        <MetricCard label="Corte de entradas" value={`${((assumptions.futureInflowHaircutBps || 0) / 100).toFixed(1)}%`} note="Premissa governada" tone="orange" />
      </section>
      <section className="director-module1__split"><article className="director-module1__panel director-module1__panel--bars"><header><div><span className="director-eyebrow">Efeito do cenário</span><h2>13 semanas</h2></div></header><FlowBars items={series} /></article><aside className="director-module1__insight"><span className="director-eyebrow">Limite do módulo</span><h2>Simular não executa</h2><p>Esta tela altera somente a leitura interna. Empréstimo, aporte e renegociação pertencem ao Módulo 5 e permanecem fora deste fluxo.</p><div className="director-module1__callout">Acréscimo de saída não comprometida: {((assumptions.uncommittedOutflowUpliftBps || 0) / 100).toFixed(1)}%</div></aside></section>
    </>}
  </ModuleShell>;
};

export default Scenarios;
